module.exports = {
  CORE_BASE_URL: 'http://localhost:8080/dcs-api',
  AUTH_BASE_URL: 'http://localhost:8000/dcs-auth',
  STORAGE_BASE_URL: 'http://localhost:9000/dcs-storage',
  google: {
    client_id: "794348079659-9eod3gbdlao1hvq0ptvpo551r7hqp3ig.apps.googleusercontent.com"
  }
};
